//Document ready
$(function() {
	InspirationSliderInit();
});

//InspirationSlider init
function InspirationSliderInit() {
    if($('.js-inspiration-slider').length) {
        $('.js-inspiration-slider').on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
            var i = (currentSlide ? currentSlide : 0) + 1;
            $('.js-inspiration-paging-info').text(i + ' ze ' + slick.slideCount);
          });
        $('.js-inspiration-slider').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                      slidesToShow: 2
                    }
                },
                {
                  breakpoint: 576,
                  settings: {
                    slidesToShow: 1
                  }
                }
              ]
        });
    }
}